import { useMemo } from 'react';

import { groupMarketsBySector, useMarketsList } from '@/features/markets';
import { useAppSelector } from '@/store/hooks';

export const useMarketsNavigationItems = () => {
  const tripTokenStatus = useAppSelector(state => state.tripToken.status);
  const { data } = useMarketsList(undefined, tripTokenStatus === 'fulfilled');
  const groupedMarkets = data?.groupedMarkets;
  const menuItems = useMemo(() => {
    return groupMarketsBySector(groupedMarkets ?? []);
  }, [groupedMarkets]);

  return { menuItems };
};
